import { useRouter } from 'next/router';
import { useEffect } from 'react';
import env from '@beam-australia/react-env';
import StyleProvider from '@/lib/theme/Provider';
import AppLoading from '@/components/AppLoading';

function RedirectPage() {
  const router = useRouter();
  const { path } = router.query;

  useEffect(() => {
    if (!path || !Array.isArray(path)) return;

    const redirectPath = path[0];
    const FRONTEGG_BASE_URL = env('FRONTEGG_BASE_URL');

    switch (redirectPath) {
      case 'register':
        window.location.href = `${FRONTEGG_BASE_URL}/oauth/account/sign-up`;
        break;
      case 'login':
        window.location.href = `${FRONTEGG_BASE_URL}/oauth/account/login`;
        break;
      default:
        router.push('/');
        break;
    }
  }, [path, router]);

  return (
    <StyleProvider>
      <AppLoading
        reason="RedirectPage.redirecting"
        messages={['Redirecting...']}
      />
    </StyleProvider>
  );
}

RedirectPage.skipProviders = true;

export default RedirectPage;
